<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img src="~@/assets/img/CITEditor/color.svg" alt="text color" title="text color" />
    </button>
    <div v-show="option" class="toolbarColor"
      @mousedown="onMouseDown"
      @keydown.enter="onKeyDown">
      <sketch-picker
        :value="value"
        @input="settingColor" />
    </div>
  </span>
</template>

<script>
import sketch from 'vue-color/src/components/Sketch.vue'

let selectionRange = null

function saveSelection () {
  if (window.getSelection) {
    const sel = window.getSelection()
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0)
    }
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange()
  }
  return null
}

function restoreSelection (range) {
  if (range) {
    if (window.getSelection) {
      var sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    } else if (document.selection && range.select) {
      range.select()
    }
  }
}

function setColor (color) {
  restoreSelection(selectionRange)
  document.execCommand('styleWithCSS', false, true)
  document.execCommand('foreColor', false, color)
}

export default {
  name: 'Color',
  props: [
    'active',
    'value',
    'option'
  ],
  components: {
    'sketch-picker': sketch
  },
  watch: {
    option (isOption) {
      if (!isOption && this.isChange === 'input') {
        setColor(this.current)
        this.ischange = null
      }
    }
  },
  data () {
    return {
      isChange: null,
      current: ''
    }
  },
  methods: {
    // open option:: text color
    onClickOption (e) {
      this.$emit('setOption', { name: 'Color', state: true })
      selectionRange = saveSelection()
    },
    settingColor (c) {
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      this.$emit('setValue', { name: 'Color', value: rgba })
      this.current = rgba
      if (this.isChange === null) {
        setTimeout(() => {
          document.execCommand('styleWithCSS', false, true)
          document.execCommand('foreColor', false, rgba)
        }, 100)
      }
    },
    onMouseDown (e) {
      if (e.target.closest('.vc-sketch') === null || e.target.tagName !== 'INPUT') {
        e.preventDefault()
        this.isChange = null
      } else {
        this.isChange = 'input'
      }
    },
    onKeyDown (e) {
      e.preventDefault()
      setColor(this.current)
      this.ischange = null
    }
  }
}
</script>
